import { router, routes } from '@/router'
// 循环放置keywords
let content = ''
routes.forEach(e => {
  if (e.meta) {
    content = content + e.meta.title + '、'
    if (e.children) {
      e.children.forEach((i, index) => {
        content = content + i.meta.title + (e.children.length - 1 == index ? '' : '、')
      })
    }
  }
})
document.querySelector('meta[name="keywords"]').setAttribute('content', content)
router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    document.title = to.meta.title
  }
  next()
})